
import { useState } from 'react';
import { IonApp, IonProgressBar } from '@ionic/react';
import { IonReactRouter } from '@ionic/react-router';
import { Route } from 'react-router-dom';

import AutoRegister from './pages/AutoRegister';

import { BarrLoaderSpiner } from './components/BarrLoaderSpiner';

/* Core CSS required for Ionic components to work properly */
import '@ionic/react/css/core.css';

/* Basic CSS for apps built with Ionic */
import '@ionic/react/css/normalize.css';
import '@ionic/react/css/structure.css';
import '@ionic/react/css/typography.css';

/* Optional CSS utils that can be commented out */
import '@ionic/react/css/padding.css';
import '@ionic/react/css/float-elements.css';
import '@ionic/react/css/text-alignment.css';
import '@ionic/react/css/text-transformation.css';
import '@ionic/react/css/flex-utils.css';
import '@ionic/react/css/display.css';

/* Theme variables */
import './theme/variables.css';

const App: React.FC = () => {

  const [showSpinner, setShowSpinner] = useState(true as boolean);
  const barrLoaderProps: any = { spinnerState: { showSpinner, setShowSpinner }, };

  return (
    <IonApp>
      <IonReactRouter basename="/registrar-mi-institucion">

        <Route path="/" exact>
          <AutoRegister />
        </Route>

        <Route path="/?cupon" exact>
          <AutoRegister />
        </Route>

        <Route path="/?success" exact>
          <BarrLoaderSpiner {...barrLoaderProps} />
          <IonProgressBar type="indeterminate"></IonProgressBar>
        </Route>

      </IonReactRouter>
    </IonApp>
  );
};


export default App;
